import {Pipe, PipeTransform} from '@angular/core';
import {capitalize} from '../../utils/string.utils';

@Pipe({name: 'capitalize'})
export class CapitalizePipe implements PipeTransform {
    transform(value: any): string {
        return capitalize(value);
    }
}
